<template>
    <div v-if="listHistory">
        <vs-tabs>
            <vs-tab v-for="object in listHistory" :label="$t(object.name)" :key="object.name">
                <template v-if="object.data">
                    <vs-card v-for="event in object.data" :key="event.uid">
                        <span class="text-lg font-semibold">{{  $moment(event.created).format('HH:mm DD MMMM YYYY')  }}</span>
                        <div :class="classForDOM.parent" class="mt-4">
                            <span class="text-lg font-normal mb-2" style="color: black">
                                {{ $t('information') }}
                            </span>
                        </div>
                        <div :class="classForDOM.parent" class="member-information mb-4 ml-4">
                            <div>
                                <table>
                                    <tr>
                                        <td class="text-base font-semibold pr-20 pb-2">
                                            {{ $t('author_edit') }}
                                        </td>
                                        <td class="text-base pr-4 pb-2">
                                            {{ event['editor'] }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-base font-semibold pr-20 pb-2">
                                            {{ $t('act') }}
                                        </td>
                                        <td class="text-base pr-4 pb-2">
                                            {{ event['type'] ? event['type'] : $t('unknown') }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-base font-semibold pr-20 pb-2">
                                            {{ $t('status_at_the_time_of_validity') }}
                                        </td>
                                        <td class="text-base pr-4 pb-2">
                                            {{ event['status'] ? event['status'] : $t('unknown') }}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <vs-button type="line"
                                   @click="event['showEdit'] = !event['showEdit']"
                                   class="w-full">
                            {{ $t('show_edit') }}
                        </vs-button>
                        <div v-if="event['showEdit'] && event.after" class="member-information mt-4 ml-4">
                            <table>
                                <tr v-for="key in Object.keys(event.after)" :key="key">
                                    <td class="text-base font-semibold pr-20 pb-2">
                                        {{ $t(key) }}
                                    </td>
                                    <td class="text-base pr-4 pb-2">
                                        <span class="block" style="color: #4db14d">{{ event.after[key] }}</span>
                                        <span class="block line-through" style="color: #ff8f8f" v-if="event.before && event.before[key]">{{ event.before[key] }}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <!--                    {{  event  }}-->
                    </vs-card>
                </template>
                <div v-else class="text-center">
                    <span>{{ $t('not_history') }}</span>
                </div>
            </vs-tab>
        </vs-tabs>
    </div>
</template>

<script>
export default {
    name: "history",
    props: {
        data: {
            type: Object,
            required: true,
        },
        applicantUid: {
            type: String,
            required: true,
        }
    },
    data(){
        return {
            listHistory: null,
            page: 2,
            classForDOM: {
                grandParent: 'flex flex-col md:flex-row justify-between',
                parent: 'flex flex-col md:flex-row justify-between items-start',
                block: 'flex flex-col w-full',
            },
        }
    },
    methods: {
        async getHistory(){
            try {
                this.$vs.loading();
                this.listHistory = await Promise.all(this.data.history.map(async (nameObject) => {
                    let response = (await this.$http.get(
                        `admissions/applicants/${ this.applicantUid }/timeline/`,
                        {
                            params: {
                                model: nameObject
                            }
                        }
                    )).data.results;



                    if (response){
                        response = await response.map(event => {
                            return {
                                ...event,
                                showEdit: false,
                            }
                        });
                    }

                    return {
                        name: nameObject,
                        data: response,
                    }
                }))

            } catch (e){

            } finally {
                this.$vs.loading.close();
            }
        }
    },
    created() {
        this.getHistory()
    }
}
</script>

<style scoped lang="scss">
.member-information{
    table {
        td {
            vertical-align: top;
            min-width: 140px;
            padding-bottom: .8rem;
            word-break: break-all;
        }
        &:not(.permissions-table) {
            td {
                @media screen and (max-width: 600px) {
                    display: block;
                }
            }
        }
    }
}
</style>
